import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import AnchorLink from '@helsenorge/designsystem-react/components/AnchorLink';
import { Projects, useResources } from '../../resources';
import { HjelpeskuffClosedEventName } from '../events';
import { trackProsesshjelp } from '../utils/analytics';
import styles from './styles.module.scss';
// Komponent for å åpne hjelpeskuffen fra andre hjelpekomponenter
const OpenHjelpeskuff = props => {
    const resources = useResources(Projects.FRAMEWORK);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const handleHjelpeskuffClosed = () => {
            setIsOpen(false);
        };
        window.addEventListener(HjelpeskuffClosedEventName, handleHjelpeskuffClosed);
        return () => {
            window.removeEventListener(HjelpeskuffClosedEventName, handleHjelpeskuffClosed);
        };
    }, []);
    const text = props.children || resources?.visHjelpeskuffTekst;
    const handleClick = () => {
        trackProsesshjelp('OpenHjelpeskuff', text);
        setIsOpen(true);
        props.onClick();
    };
    if (!text) {
        return null;
    }
    return (_jsx(AnchorLink, { asChild: true, className: styles.openhjelpeskuff, children: _jsx("button", { onClick: handleClick, "aria-haspopup": "dialog", "aria-expanded": isOpen, children: text }) }));
};
export default OpenHjelpeskuff;
